module.exports = __webpack_public_path__ + "static/media/1POLICY24.4136145f.jpg";